import React from 'react'
import Language from '../Components/Language/Language'


const LangView = () => {
  return (
    // <div className='app-container'>
    <div>
      <Language />
    </div>
  )
}

export default LangView